export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-copyright">©kaspartiri 2025</div>
          <div className="footer-links">
            <a href="/rss.xml">rss</a>
            <a href="/sitemap.xml">sitemap</a>
            <a href="/privacy">privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

